const baseURL = 'https://' + window.location.hostname // 'https://local.website.dev'
export const legacy = 'http://wdev.flexlink.com/myflexlink/'

export function getURL (path) {
  return `${baseURL}${path}`
}

export function getCookie (cname) {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}